<template>
    <v-container fluid>
        <h3 v-if="$store.state.inscritos.length > 1">Listado de corredores que forman la inscripción</h3>
        <h3 v-else>Datos de la inscripción</h3>
        <v-expansion-panels focusable multiple v-if="$store.state.inscritos.length > 1">
            <v-expansion-panel
                    v-for="(persona, idx) in getInscritos" :key="idx"
            >
                <v-expansion-panel-header>{{ persona.nombre.toUpperCase() }} {{ persona.apellidos.toUpperCase() }}
                    , <strong>7 €</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12">
                            <v-simple-table fixed-header >
                                <template v-slot:default>
                                    <thead style="background-color: orange; text-align: center;">
                                    <tr>
                                        <td>Nombre</td>
                                        <td>Apellidos</td>
                                        <td>DNI del tutor</td>
                                        <td>Email del tutor</td>
                                        <td>Teléfono del tutor</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr style="text-align: center;">
                                        <td>{{ persona.nombre }}</td>
                                        <td>{{ persona.apellidos }}</td>
                                        <td>{{ persona.dni_tutor }}</td>
                                        <td>{{ persona.email_tutor }}</td>
                                        <td>{{ persona.tlfno_tutor }}</td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>

                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-row v-else v-for="(persona, index) in getInscritos" :key="index">
            <v-col cols="12">
                <v-simple-table fixed-header >
                    <template v-slot:default>
                        <thead style="background-color: orange; text-align: center;">
                        <tr>
                            <td>Nombre</td>
                            <td>Apellidos</td>
                            <td>DNI del tutor</td>
                            <td>Email del tutor</td>
                            <td>Teléfono del tutor</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr style="text-align: center;">
                            <td>{{ persona.nombre }}</td>
                            <td>{{ persona.apellidos }}</td>
                            <td>{{ persona.dni_tutor }}</td>
                            <td>{{ persona.email_tutor }}</td>
                            <td>{{ persona.tlfno_tutor }}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row cols="12">
            <v-col cols="12">
                <h3>Total de la inscripción: {{ calcularTotal() }} €</h3>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="6">
                <form v-if="tpv" :action="tpv.url" method="POST" ref="frmPago">
                    <input type="hidden" name="Ds_SignatureVersion" :value="tpv.version">
                    <input type="hidden" name="Ds_MerchantParameters" :value="tpv.params">
                    <input type="hidden" name="Ds_Signature" :value="tpv.signature">
                </form>
                <v-btn block large color="success" @click="pagar" :disabled="!pagarOk || !tpv">Pagar</v-btn>

            </v-col>
            <v-col cols="6">
                <v-btn block large color="info" @click="volver">Volver atrás</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    import { mapActions } from 'vuex'
    import {insService} from "../_services";

    /* eslint-disable no-debugger */

    export default {
        name: "ResumenInfantil",
        props: ['referencia'],
        data() {
            return {
                pagarOk: false,
                tpv: null,
                pagador: {
                    persona: {
                        nombre:'',
                        dni:'',
                        email:''
                    },
                    referencia: this.referencia,
                    corredor: ''
                },
            }
        },
        created() {
            if(this.$store.state.referencia === null)
                this.addReference(this.referencia)
            if (this.$store.state.inscritos.length == 1) {
                this.pagador.persona.nombre = this.$store.state.inscritos[0].nombre_tutor
                this.pagador.persona.dni = this.$store.state.inscritos[0].dni_tutor
                this.pagador.persona.email = this.$store.state.inscritos[0].email_tutor
                this.pagador.corredor = "SI"
            }
            insService.getTpv(this.referencia).then( rdo => {
                this.tpv = rdo
                this.pagarOk = true
            })
        },
        computed: {
            getInscritos() {
                return this.$store.state.inscritos
            },
        },
        methods:{
            ...mapActions(['addReference']),

            calcularTotal() {
                return  parseInt( this.$store.state.inscritos.length * 7 )
            },
            pagar(){
                insService.setPagador(this.pagador).then( rdo => {
                    //eslint-disable-next-line
                    console.log(rdo)
                    if(rdo.pagador_id) {
                        this.$refs.frmPago.submit()
                    }
                })
            },
            volver() {
                this.$router.go(-1)
            }
        }
    }
</script>